module.exports = __webpack_public_path__ + "img/seccion4.2.4874cfc3.png";